<template>
    <div class="main">
        <MyHeader index="0"></MyHeader>
        <div class="banner">
            <div class="txt" style="background: rgba(0,0,0,0.3);padding:5px;">
            <p class="ch">让我们共同创造世界级的洁净空气</p>
            <p class="en">LET'S CREATE WORLD-CLASS CLEAN AIR TOGETHER</p>
            </div>
            <img id="#header" @click="down" class="down" src="./image/down.png" alt="down">
        </div>
        <div class="container">
            <div class="purpose">
                <div class="bigTitle">
                    <h2>{{$t('tit.title')}}</h2>
                </div>
                       
                <div style="width: 534px;margin: 20px auto 0;margin-bottom:40px;font-size: 24px;font-weight:600;color: #999999;line-height: 25px;text-align: center;"  v-if=" this.$i18n.locale != 'zh_CN'">To achieve a world-class air quality in China and protect the climate by</div>
                <!--<h5 class="describe"  v-if=" this.$i18n.locale != 'zh_CN'">{{$t('txt.text01')}}</h5>-->
                <h5 class="describe" style="width: 395px" v-if=" this.$i18n.locale != 'zh_CN'">{{$t('txt.text')}}</h5>
                <h5 class="describe" v-if=" this.$i18n.locale == 'zh_CN'">{{$t('txt.text')}}</h5>
                <!--<h5 class="describe"  v-if=" this.$i18n.locale != 'zh_CN'">{{$t('txt.text02')}}</h5>-->
                <h5 class="describe" style="width: 484px" v-if=" this.$i18n.locale != 'zh_CN'">{{$t('txt.text21')}}</h5>
                <!--<h5 class="describe"  v-if=" this.$i18n.locale != 'zh_CN'">{{$t('txt.text03')}}</h5>-->
                <h5 class="describe"  v-if=" this.$i18n.locale != 'zh_CN'">{{$t('txt.text2')}}</h5>
          
                
                <div class="button">
                    <a :class="leftButton"  @click="leftRoll" style="margin-right: 24px;" href="javascript:void (0);">{{$t('label.title')}}</a>
                    <a :class="rightButton"  @click="rightRoll" href="javascript:void (0);">{{$t('label.title1')}}</a>
                </div>
                <div class="expert" v-if=" this.$i18n.locale == 'zh_CN'">
                    <span class="roll" @click="rollRight"></span>
                    <div class="expertList">
                        <ul :style="rollStyle" v-if="figureType === 1">
                            <li v-for="item in expertList1">
                                <router-link :to="'/figureInfo/' + item.id">
                                    <div class="photo">
                                        <img :src="item.avatar" alt="photo">
                                    </div>
                                    <h3 class="name">{{item.name}}</h3>
                                    <h4 class="school">{{item.organization}}</h4>
                                    <h6 class="briefing" v-html="item.brief"></h6>
                                </router-link>
                            </li>
                        </ul>
                        <ul :style="rollStyle" v-if="figureType === 2">
                            <li v-for="item in expertList2">
                                <router-link :to="'/figureInfo/' + item.id">
                                    <div class="photo">
                                        <img :src="item.avatar" alt="photo">
                                    </div>
                                    <h3 class="name">{{item.name}}</h3>
                                    <h4 class="school">{{item.organization}}</h4>
                                    <h6 class="briefing" v-html="item.brief"></h6>
                                </router-link>
                            </li>
                        </ul>
                    </div>
                    <span class="roll" @click="rollLeft"></span>
                </div>
               
                <div class="expert" v-if=" this.$i18n.locale == 'en_US'">
                    <span class="roll" @click="rollRight"></span>
                    <div class="expertList">
                        <ul :style="rollStyle" v-if="figureType === 1">
                            <li v-for="item in expertList1">
                                <router-link :to="'/figureInfo/' + item.id">
                                    <div class="photo">
                                        <img :src="item.avatar" alt="photo">
                                    </div>
                                    <h3 class="name">{{item.name_en}}</h3>
                                    <h4 class="school">{{item.organization_en}}</h4>
                                    <h6 class="briefing" v-html="item.brief_en"></h6>
                                </router-link>
                            </li>
                        </ul>
                        <ul :style="rollStyle" v-if="figureType === 2">
                            <li v-for="item in expertList2">
                                <router-link :to="'/figureInfo/' + item.id">
                                    <div class="photo">
                                        <img :src="item.avatar" alt="photo">
                                    </div>
                                    <h3 class="name">{{item.name_en}}</h3>
                                    <h4 class="school">{{item.organization_en}}</h4>
                                    <h6 class="briefing" v-html="item.brief_en"></h6>
                                </router-link>
                            </li>
                        </ul>
                    </div>
                    <span class="roll" @click="rollLeft"></span>
                </div>
                
            </div>
        </div>

        <div class="partners">
            <div class="container">
                <span class="partnerLeft" @click="partnerLeft"></span>
                <div class="more">
                    <router-link to="/partner">{{$t('Hyperlinks.see')}}</router-link>
                    <img src="./image/yy.png" alt="yy">
                </div>
                <div class="title">
                    <h2>{{$t('tit.partners')}}</h2>
                </div>
                <div  class="list">
                    <!--translateX(-1220px)-->
                    <ul :style="jointRoll" id="partners">
                        <li><img src="./image/logo5/partner1.png" alt=""></li>
                        <li><img src="./image/logo5/partner2.png" alt=""></li>
                        <li><img src="./image/logo5/partner3.png" alt=""></li>
                        <li><img src="./image/logo5/partner4.png" alt=""></li>
                        <li><img src="./image/logo5/partner5.png" alt=""></li>
                        <li><img src="./image/logo5/partner6.png" alt=""></li>
                        <li><img src="./image/logo5/partner7.png" alt=""></li>
                        <li><img src="./image/logo5/partner8.png" alt=""></li>
                        <li><img src="./image/logo5/partner9.png" alt=""></li>
                        <li><img src="./image/logo5/partner10.png" alt=""></li>
                        <li><img src="./image/logo5/partner11.png" alt=""></li>
                        <li><img src="./image/logo5/partner12.png" alt=""></li>
                        <li><img src="./image/logo5/partner13.png" alt=""></li>
                        <li><img src="./image/logo5/partner14.png" alt=""></li>
                        <li><img src="./image/logo5/partner15.png" alt=""></li>
                        <li><img src="./image/logo5/partner16.png" alt=""></li>
                        <li><img src="./image/logo5/partner17.png" alt=""></li>
                        <li><img src="./image/logo5/partner18.png" alt=""></li>
                        <li><img src="./image/logo5/partner19.png" alt=""></li>
                        <li><img src="./image/logo5/partner20.png" alt=""></li>
                        <li><img src="./image/logo5/partner21.png" alt=""></li>
                        <li><img src="./image/logo5/partner22.png" alt=""></li>
                        <li><img src="./image/logo5/partner23.png" alt=""></li>
                        <li><img src="./image/logo5/partner24.png" alt=""></li>
                        <li><img src="./image/logo5/partner25.png" alt=""></li>
                        <li><img src="./image/logo5/partner26.png" alt=""></li>
                        <li><img src="./image/logo5/partner27.png" alt=""></li>
                        <li><img src="./image/logo5/partner28.png" alt=""></li>
                        <li><img src="./image/logo5/partner29.png" alt=""></li>
                        <li><img src="./image/logo5/partner30.png" alt=""></li>
                        <li><img src="./image/logo5/partner31.png" alt=""></li>
                        <li><img src="./image/logo5/partner32.png" alt=""></li>
                        <li><img src="./image/logo5/partner33.png" alt=""></li>
                        <li><img src="./image/logo5/partner34.png" alt=""></li>
                        <li><img src="./image/logo5/partner35.png" alt=""></li>
                        <li><img src="./image/logo5/partner36.png" alt=""></li>
                        <li><img src="./image/logo5/partner37.png" alt=""></li>
                        <li><img src="./image/logo5/partner38.png" alt=""></li>
                        <li><img src="./image/logo5/partner39.png" alt=""></li>
                    </ul>
                </div>
                <span class="partnerRight" @click="partnerRight"></span>
            </div>
        </div>
        <div class="news">
            <div class="container">
                <div class="title">
                    <h2>{{$t('tit.news')}}</h2>
                </div>
                <div class="link">
                    <router-link to="/news/69">
                        <i>{{$t('Hyperlinks.see')}}</i>
                        <img src="./image/more-next.png" alt="more">
                    </router-link>
                </div>
                <div class="list">
                    <ul>
                        <li v-for="item in articleList">
                            <router-link :to="{name:'newsInfo',params:{id:item.id}}">
                                <div class="newsImg"><img :src="item.thumb_image" alt=""></div>
                                <div class="newsInfo">
                                    <h2>{{item.name}}</h2>
                                    <b>{{item.release}}</b>
                                </div>
                            </router-link>
                        </li v>
                    </ul>
                </div>
            </div>
        </div>
        <div class="feature">
            <div class="container">
                <div class="imgBody left">
                    <router-link to="/report">
                        <img src="./image/feature1.png" alt="feature" v-if=" this.$i18n.locale == 'zh_CN'">
                        <img src="./image/feature3.png" alt="feature" v-if=" this.$i18n.locale == 'en_US'">
                    </router-link>

                </div>
                <div class="imgBody right">
                    <router-link to="/resources/77">
                        <img src="./image/feature2.png" alt="feature" v-if=" this.$i18n.locale == 'zh_CN'">
                        <img src="./image/feature4.png" alt="feature" v-if=" this.$i18n.locale == 'en_US'">
                    </router-link>

                </div>
            </div>
        </div>
        <MyFooter></MyFooter>
    </div>
</template>

<script>
    import $ from 'jquery'
    import MyHeader from './common/MyHeader'
    import MyFooter from './common/MyFooter'
    import filter from '../filter.js';
    import {createExpert, getExpertList, getExpertDetails, deleteExpert, putExpert} from '@/services/expert';
    import {createArticle, getArticleList, getArticleDetails, deleteArticle, putArticle} from '@/services/article';

    export default {
        name: "index",
        data(){
            return{
                rollStyle:{
                    transform: 'translateX(0)'
                },
                jointRoll:{
                    transform: 'translateX(0)'
                },
                nextStyle:{
                    opacity: 1,
                    display:'block'
                },
                leftButton:'on',
                rightButton:'',
                index:0,
                expertIndex:0,
                pageJson:{
                    page_size:999,
                    page:1,
                    department:1,
                    language:2,
                },
                article:{
                    page_size:4,
                    page:1,
                    category_id:[69,70,71]
                },
                expertList1: [],
                expertList2: [],
                articleList:[],
                figureType:1
            }
        },
        components: { MyHeader,MyFooter },
        mounted(){
        	if (this.$i18n.locale == "zh_CN") {
        		this.pageJson.language = 2;
        	} else {
        		this.pageJson.language = 3;
        	}	
            for (let i = 1 ;i <= 2 ;i++) {
                this.pageJson.department = i;
                this.getList(res => {
                    let list = res.items;
                    if (i === 1){
                        this.expertList1 = list;
                    } else if (i === 2){
                        this.expertList2 = list;
                    }
                });
            }
            this.getArticleList();
        },
        methods:{
            getArticleList(){
                getArticleList(this.article).then(res => {
                    let list = res.items;
                    for (let i in list){
                        let item = list[i];
                        item.release = filter.dateFormat(item.release_time, "yyyy-mm-dd");
                    }
                    this.articleList = list;
                }).catch(err => {});
            },
            getList(cb){
                getExpertList(this.pageJson).then(res => {
                    if (typeof cb === 'function'){
                        cb(res);
                    }
                }).catch(err => {});
            },
            down(){
                var $body = (window.opera) ? (document.compatMode === "CSS1Compat" ? $('html') : $('body')) : $('html,body');
                $body.animate({scrollTop: 952}, 800);
            },
            rollLeft(){
                let that = this, right = 1135, partnerNum = 0;
                if (this.figureType === 1) {
                    partnerNum = that.expertList1.length;
                } else {
                    partnerNum = that.expertList2.length;
                }
                let rollNUm = Math.ceil(partnerNum/4);
                if (this.expertIndex < (rollNUm - 1)) {
                    this.expertIndex ++;
                    this.rollStyle.transform = `translateX(-${right * this.expertIndex}px)`;
                }
            },
            rollRight(){
                let right = 1135;
                if (this.expertIndex > 0) {
                    this.expertIndex --;
                    this.rollStyle.transform = `translateX(-${right * this.expertIndex}px)`;
                }
            },
            leftRoll(){
                const that = this;
                this.figureType = 1;
                this.expertIndex = 0;
                this.leftButton = 'on';
                this.rightButton = '';
                this.rollStyle['-webkit-transition'] = 'all 0s';
                this.rollStyle.transition = 'all 0s';
                this.rollStyle.transform = 'translateX(0)';
                setTimeout(function () {
                    that.rollStyle['-webkit-transition'] = 'all 0s';
                    that.rollStyle.transition = 'all 0.8s';
                },50);
            },
            rightRoll(){
                const that = this;
                this.figureType = 2;
                this.expertIndex = 0;
                this.leftButton = '';
                this.rightButton = 'on';
                this.rollStyle['-webkit-transition'] = 'all 0s';
                this.rollStyle.transition = 'all 0s';
                this.rollStyle.transform = 'translateX(0)';
                setTimeout(function () {
                    that.rollStyle['-webkit-transition'] = 'all 0s';
                    that.rollStyle.transition = 'all 0.8s';
                },50);
            },
            partnerRight(){
                let that = this, right = 1220;
                let partnerNum = $('#partners li').length;
                let rollNUm = Math.ceil(partnerNum/5);
                if (this.index < (rollNUm - 1)) {
                    this.index ++;
                    this.jointRoll.transform = `translateX(-${right * this.index}px)`;
                }
            },
            partnerLeft(){
                let right = 1220;
                if (this.index > 0) {
                    this.index --;
                    this.jointRoll.transform = `translateX(-${right * this.index}px)`;
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .main{
        .banner{
            width: 100%;
            height: 814px;
            background: url("./image/banner.png") no-repeat center center;
            background-size: cover;
            position: relative;
            .txt{
                position: absolute;
                left:225px;
                top: 350px;
                p{
                    color:white;
                }
                .ch{
                    font-size: 46px;
                }
                .en{
                    font-size: 30px;
                    margin-top: 10px;
                }
            }
            .down{
                cursor: pointer;
                position: absolute;
                bottom: 0;
                left: 50%;
                transform: translate(-50%,50%);
            }
        }
        .purpose{
            margin-top: 80px;
            .bigTitle{
                width:500px;
                height:95px;
                margin: 0 auto;
                background: url("./image/our mission.png") no-repeat center center ;
                background-size: 100% ;
                h2{
                    color: #304656;
                    font-weight:bold;
                    font-size:28px;
                    line-height: 38px;
                    height: 38px;
                    padding-top: 52px;
                    text-align: center;
                }
            }
            .describe{
                width:534px;
                margin: 20px auto 0;
                font-size:14px;
                color: #999999;
                line-height:25px;
                text-align: center;
            }
            .button{
                width: 224px;
                margin: 40px auto 0;
                a{
                    display: inline-block;
                    width: 98px;
                    height: 38px;
                    line-height: 38px;
                    text-align: center;
                    color: #666666;
                    font-size:14px;
                    border: 1px solid #E0E0E0;
                }
                .on{
                    background-color: #13AE67;
                    border: 1px solid #13AE67;
                    color: #FFFFFF;
                }
            }
            .expert{
                width: 100%;
                position: relative;
                .roll{
                    transition: all .8s;
                    cursor: pointer;
                    width: 44px;
                    height: 44px;
                    display: block;
                    background: url("./image/left.png") no-repeat center center;
                    background-size: 100% 100%;
                    position: absolute;
                    z-index: 20;
                    right:0;
                    top: 95px;
                    transform: translate(0,-50%);
                    &:nth-of-type(1){
                        background: url("./image/right.png") no-repeat center center;
                        left: 0;
                    }
                }
                .expertList{
                    width: 1072px;
                    margin: 60px auto 0;
                    overflow: hidden;
                    ul{
                        transition: all .8s;
                        white-space: nowrap;
                        li{
                            float: none;
                            display: inline-block;
                            width:220px;
                            margin-right: 64px;
                            &:last-child{
                                margin-right: 0;
                            }
                            .photo{
                                margin: 0 auto;
                                width:190px;
                                height:190px;
                                border-radius: 50%;
                                overflow: hidden;
                                img{
                                    width: 100%;
                                }
                            }
                            .name{
                                width: 100%;
                                text-align: center;
                                color: #001951;
                                margin-top: 12px;
                                height:24px;
                                line-height:24px;
                                font-weight:bold;
                            }
                            .school{
                                text-align: center;
                                font-size:12px;
                                width: 100%;
                                margin-top: 8px;
                                color: #666666;
                                height:16px;
                                line-height:16px;
                            }
                            .briefing{
                                margin-top: 8px;
                                text-align: left;
                                font-weight:bold;
                                width: 100%;
                                color: #666666;
                                font-size: 12px;
                                line-height:16px;
                                display: -webkit-box;
                                -webkit-box-orient: vertical;
                                -webkit-line-clamp: 2;
                                overflow: hidden;
                                white-space: normal;
                            }
                        }
                    }
                }
            }

        }
        .partners{
            margin-top: 64px;
            background-image: linear-gradient(-223deg, #00A0E9 0%, #13AE67 100%);
            background-size: cover;
            height: 280px;
            .container{
                position: relative;
                .more{
                    position: absolute;
                    overflow: hidden;
                    top: 50px;
                    right: 0;
                    a{
                        font-size: 14px;
                        line-height: 20px;
                        height: 20px;
                        display: block;
                        float: left;
                        color: #fff;
                    }
                    img{
                        cursor: pointer;
                        float: left;
                        width: 20px;
                    }
                }
                .title{
                    h2{
                        font-size: 28px;
                        line-height: 38px;
                        height: 38px;
                        margin-top: 32px;
                        text-align: center;
                        color: #FFFFFF;
                        letter-spacing: 0;
                        font-weight: bold;
                    }
                }
                .list{
                    width: 1086px;
                    margin: 55px auto 0;
                    overflow: hidden;
                    ul{
                        white-space: nowrap;
                        transition: all .8s;
                        li{
                            float: none;
                            display: inline-block;
                            margin-right: 134px;
                            &:last-child{
                                margin-right:0;
                            }
                            img{
                                width: 110px;
                            }
                        }
                    }

                }
                .partnerLeft{
                    left: 0;
                    transition: all .3s;
                    background: url("./image/zz.png") no-repeat center center;
                    background-size: 100% 100%;
                    &:hover{
                        background: url("./image/zz-on.png") no-repeat center center;
                    }
                }
                .partnerRight{
                    right: 0;
                    transition: all .3s;
                    background: url("./image/yy.png") no-repeat center center;
                    background-size: 100% 100%;
                    &:hover{
                        background: url("./image/yy-on.png") no-repeat center center;
                    }
                }
                span{
                    position: absolute;
                    bottom: 32px;
                    display: block;
                    width: 44px;
                    height: 44px;
                }
            }
        }
        .news{
            padding: 42px 0 88px;
            background: #F4F4F4;
            .container{
                overflow: visible;
                .title{
                    h2{
                        text-align: center;
                        font-size: 28px;
                        color: #304656;
                        font-weight:bold;
                        height: 38px;
                        line-height: 38px;
                    }
                }
                .link{
                    width: 100%;
                    margin-top: 10px;
                    overflow: hidden;
                    a{
                        display: block;
                        float: right;
                        overflow: hidden;
                        i{
                            float: left;
                            color: #13AE67;
                            display: block;
                            height: 20px;
                            line-height: 20px;
                            font-size: 14px;
                        }
                        img{
                            margin-left: 9px;
                            margin-top: 5px;
                            float: left;
                        }
                    }
                }
                .list{
                    width: 100%;
                    margin-top: 35px;
                    ul{
                        width: 100%;
                        height: 330px;
                        li{
                            float: left;
                            width:262px;
                            margin-right: 50px;
                            transition: all 0.3s;
                            &:hover{
                                box-shadow: 0 5px 10px rgba(0, 0, 0, 0.3);
                                .newsInfo{
                                    h2{
                                        color: #09A7A9;
                                    }
                                }
                            }
                            &:last-child{
                                margin-right: 0;
                            }
                            .newsImg{
                                width: 100%;
                                height:197px;
                                overflow: hidden;
                                img{
                                    width: 100%;
                                }
                            }
                            .newsInfo{
                                width: 100%;
                                background: #fff;
                                padding: 16px 0;
                                h2{
                                    width:230px;
                                    margin: 0 auto;
                                    color: #333333;
                                    font-size:14px;
                                    font-weight:600;
                                    line-height:20px;
                                    transition: all 0.3s;

                                }
                                b{
                                    display: block;
                                    width:230px;
                                    margin: 12px auto 0;
                                    color: #999999;
                                    font-size: 12px;
                                    height: 16px;
                                    line-height: 16px;
                                }
                            }
                        }
                    }
                }
            }
        }
        .feature{
            padding-top: 40px;
            padding-bottom: 48px;
            .container{
                overflow: hidden;
                .imgBody{
                    width: 575px;
                    height: 323px;
                    img{
                        width: 100%;
                    }
                }
                .left{
                    float: left;
                }
                .right{
                    float: right;
                }

            }
        }
    }

</style>
